import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

import DoughnutChartComponent from './DoughnutChartComponent';
import BadgeComponent from './BadgeComponent';

const BuildGaugeComponent = ({
  title,
  link,
  pieData,
  completed,
  max,
  badge,
  pieSlices
}) => (
  <Col md={3}>
    <Row>
      <Col md={8} mdOffset={2}>
        <DoughnutChartComponent
          subtitle={`${completed} / ${max}`}
          height={300}
          title={title}
          link={link}
          data={pieData}
          slices={pieSlices}
        />
      </Col>
    </Row>
    <Row>
      <Col md={12} style={{ paddingTop: '15px' }}>
        <BadgeComponent {...badge} />
      </Col>
    </Row>
  </Col>
);

BuildGaugeComponent.propTypes = {
  title: PropTypes.string.isRequired,
  completed: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  badge: PropTypes.object.isRequired,
  link: PropTypes.string,
  pieData: PropTypes.arrayOf(PropTypes.number).isRequired,
  pieSlices: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    colour: PropTypes.string.isRequired
  })).isRequired
};

export default BuildGaugeComponent;


// WEBPACK FOOTER //
// src/Components/BuildGaugeComponent.jsx